
<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("report.report_accounting_home_liability.title") }}</b>
            </div>

            <div class="col-md-12 col-ld-12 col-sd-12">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span
                            style="margin-left:5px;display:inline-block;"
                          >{{ $t("service_history.date_from") }}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="search.from_date"
                      v-model="search.from_date"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span
                            style="margin-left:5px;display:inline-block;"
                          >{{ $t("service_history.date_to") }}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker :config="options" :value="search.to_date" v-model="search.to_date"></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <!-- <label>{{ $t("receipt.apartment_code") }}</label> -->
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-home"></i>
                    </div>

                    <!--:defaultSelected="account.bank_code ? account.bank_code.id : null"-->
                    <lte-select2
                      :options="apartment_list"
                      @change="onSelectApartment"
                      v-model="search.apartment_code"
                    ></lte-select2>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-warning pull-left"
                  @click="onSearch"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("common.search") }}
                </button>
              </div>
            </div>
          </div>

          <!-- ------------------------------------------------------------------------- -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <b>
                <h3 class="box-title">{{ $t(`report_accounting_home_liability_detail.title`) }}</h3>
              </b>
            </div>

            <div class="box-body">
              <div class="row" v-if="this.search_result.length > 0">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-md-4 col-lg-4">
                      <b>{{$t('report_accounting_home_liability_detail.apartment_code')}}:</b>
                      {{search.apartment_code}}
                    </div>
                    <div class="col-md-4 col-lg-4">
                      <b>{{$t('report_accounting_home_liability_detail.from_date')}}:</b>
                      {{search.from_date}}
                      <br />
                      <b>{{$t('report_accounting_home_liability_detail.closing_balance_begin')}}</b>
                      <br />
                      <b
                        class="report_accounting_home_liability_detail_left"
                      >{{$t('report_accounting_home_liability_detail.in_debt')}} :</b>
                      <b>{{cal_in_debt_first()}}</b>
                      <br />
                      <b
                        class="report_accounting_home_liability_detail_left"
                      >{{$t('report_accounting_home_liability_detail.yes')}} :</b>
                      <b style="color:red">({{cal_yes_first()}})</b>
                      <br />
                    </div>
                    <div class="col-md-4 col-lg-4">
                      <b>{{$t('report_accounting_home_liability_detail.from_date')}}:</b>
                      {{search.to_date}}
                      <br />
                      <b>{{$t('report_accounting_home_liability_detail.closing_balance_end')}}</b>
                      <br />
                      <b
                        class="report_accounting_home_liability_detail_left"
                      >{{$t('report_accounting_home_liability_detail.in_debt')}} :</b>
                      <b>{{cal_in_debt_final()}}</b>
                      <br />
                      <b
                        class="report_accounting_home_liability_detail_left"
                      >{{$t('report_accounting_home_liability_detail.yes')}} :</b>
                      <b style="color:red">({{cal_yes_final()}})</b>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ------------------------------------------------------------------------- -->
          <div class="row">
            <div>
              <div class="margin-down-15"></div>
              <div class="col-xs-12 table-responsive">
                <table class="table table-hover">
                  <thead>
                    <th>{{$t('report_accounting_home_liability_detail.date')}}</th>
                    <th>{{$t('report_accounting_home_liability_detail.invoice_code')}}</th>
                    <th>{{$t('report_accounting_home_liability_detail.explaination')}}</th>
                    <th>{{$t('report_accounting_home_liability_detail.cash')}}</th>
                    <th>{{$t('report_accounting_home_liability_detail.number_in_debt')}}</th>
                    <th>{{$t('report_accounting_home_liability_detail.number_yes')}}</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in search_result_detail" :key="index">
                      <td class="col-sm-1 col-md-1 col-lg-1">
                        <div>{{formatDateTime(item.date, 'YYYY-MM-DD hh:mm:ss', 'DD/MM/YYYY hh:mm:ss')}}</div>
                      </td>
                      <td class="col-sm-1 col-md-1 col-lg-1">
                        <div>{{item.invoice_code}}</div>
                      </td>
                      <td class="col-sm-5 col-md-5 col-lg-5">
                        <div>{{item.explaination}}</div>
                      </td>
                      <td class="col-sm-1 col-md-1 col-lg-1">
                        <div v-if="item.is_cash_paid == false">{{formatNumber(item.cash)}}</div>
                        <div v-else style="color:red">({{formatNumber(item.cash)}})</div>
                      </td>
                      <td class="col-sm-1 col-md-1 col-lg-1">
                        <div>{{formatNumber(item.closing_trade_payable)}}</div>
                      </td>
                      <td class="col-sm-1 col-md-1 col-lg-1">
                        <div style="color:red">({{formatNumber(item.closing_momo)}})</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
      </row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import LTEChart from '@/components/LTEChart'
// import LTETable from "@/components/LTETable.vue";
// import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
// import Paginator from "@/components/Paginator.vue";
import datePicker from "vue-bootstrap-datetimepicker";
// // import DateRangePicker2 from '@/components/LTEDateRangePicker2.vue'
// import Select2 from '@/components/LTESelect2Input.vue'

// import XLSX from "xlsx";
import moment from "moment";

// import vue-good-table

import Select2 from "@/components/LTESelect2Input.vue";

// vue-input-tag
// import InputTag from "vue-input-tag";
import utils from '@/lib/utils';
import i18n from "../../lang";

export default {
  name: "ReportAccountingHomeLiabilityDetail",
  data() {
    return {
      search: {
        from_date: null,
        to_date: null,
        apartment_code: ""
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      search_result: [],
      search_result_detail: [],
      apartment_list: [],
      isLoading: false
    };
  },
  watch: {
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.GET_APARTMENT_LIST_NO_PAGE_DATA.forEach((apartment, i) => {
        this.apartment_list.push({
          id: apartment.id,
          text: apartment.apartment_code,
          momo: apartment.momo
        });
      });
    }
  },
  computed: {
    ...mapGetters("accountingHomeLiabilityModule", {
      search_accounting_home_liability_list:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST",
      search_accounting_home_liability_list_detail:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL"
    }),
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_LIST_NO_PAGE_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    // Nợ đầu kì
    // Author: loitt
    // Input: this.search_result
    // Output: get first line number with open_trade_payable
    cal_in_debt_first() {
      if (this.search_result.length <= 0) return 0;
      return this.formatNumber(this.search_result[0].closing_trade_payable_min);
    },
    // Nợ cuối kì
    // Author: loitt
    // Input: this.search_result
    // Output: get last line number with open_trade_payable
    cal_in_debt_final() {
      if (this.search_result.length <= 0) return 0;
      return this.formatNumber(
        this.search_result[0].closing_trade_payable_max
      );
    },
    // Có đầu kì
    // Author: loitt
    // Input:
    // Output:
    cal_yes_first() {
      if (this.search_result.length <= 0) return 0;
      return this.formatNumber(
        this.search_result[0].closing_trade_payable_yes_min
      );
    },
    // Có cuối kì
    // Author: loitt
    // Input:
    // Output:
    cal_yes_final() {
      if (this.search_result.length <= 0) return 0;
      return this.formatNumber(
        this.search_result[0].closing_trade_payable_yes_max
      );
    },

    formatNumber(number) {
      return utils.formatNumber(utils.makeRoundNumber(number));
    },
    formatDateTime: function(dateTime, fromFormat, toFormat) {
      if (!utils.isNull(dateTime)) {
        return utils.formatDateTime(dateTime, fromFormat, toFormat);
      }
    },
    getFullName(firstname, lastname) {
      return utils.getFullName(firstname, lastname, i18n.locale);
    },

    initializeDate() {
      this.search.from_date = moment(new Date(), this.options.format).format("DD/MM/YYYY");
      this.search.to_date = moment(new Date(), this.options.format).format("DD/MM/YYYY");
    },

    // Excute search
    // Author: loitt
    // Input:
    // const data = {
    //   from_date: from_date,
    //   to_date: to_date,
    //   apartment_code: this.search.apartment_code
    // };
    // Output: list result
    onSearch() {
      let from_date = utils.formatSqlDate(this.search.from_date, this.options.format, "DD/MM/YYYY hh:mm:ss");
      let to_date = utils.formatSqlDate(this.search.to_date, this.options.format, "DD/MM/YYYY hh:mm:ss");

      if (utils.isNull(this.search.apartment_code)) {
        this.ON_SHOW_TOAST({
          message: this.$t(
            "report_accounting_home_liability_detail.error.apartment_code"
          ),
          styleType: "danger"
        });
        return;
      }
      const data = {
        from_date: from_date,
        to_date: to_date,
        apartment_code: this.search.apartment_code
      };
      this.get_search_accounting_home_liability_list_detail(data)
      this.get_search_accounting_home_liability_list(data)
    },
    get_search_accounting_home_liability_list_detail(data){
      this.isLoading = true;
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL(data)
        .then(
          function(res) {
            this.search_result_detail = res.data;
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    get_search_accounting_home_liability_list(data){
      this.isLoading = true;
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST(data)
        .then(
          function(res) {
            if (res.data.length > 0) {
              this.search_result = res.data;
            }
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    formatTotalFee(total_fee, isFormat = false) {
      if (total_fee != undefined) {
        total_fee = utils.makeRoundNumber(total_fee);
        let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == null ? 0 : rs;
        // return  (rs == 0 && isFormat) ? "-" : rs;
      }
      return 0;
    },

    onSelectApartment: function(item, reset_data = true) {
      this.search.apartment_code = item.text.trim();
    },

    ...mapActions("accountingHomeLiabilityModule", [
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL",
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_LIST",
      "ON_SHOW_TOAST"
    ])
  },
  mounted() {
    this.isLoading = true;
    const apartment_data = {
      params: {
        apt_type: 1
      }
    };
    this.GET_APARTMENT_LIST(apartment_data).then(
      function() {
        this.isLoading = false;
      }.bind(this)
    ).catch(
      function(error) {
        this.isLoading = false;
      }.bind(this)
    );

    this.initializeDate();
  },
  components: {
    loading: Loading,
    "date-picker": datePicker,

    "lte-select2": Select2,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-down-15 {
  margin-bottom: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.label-red {
  background-color: red !important;
}

.report_accounting_home_liability_detail_left {
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/Report/ReportAccountingHomeLiabilityDetail.vue